import './App.css';
import FamilyTree from './component/familyTree/FamilyTree';
import Procuration from './component/Procuration';
import IndianAncestor from './component/indian_ancestor/IndianAncestor';
import Creneau from './component/creneau/Creneau';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Niveau1 from './component/levels/niveau-1/FamilyTree';
import Niveau2 from './component/levels/niveau-2/FamilyTree';
import Niveau3 from './component/levels/niveau-3/FamilyTree';
import Niveau3AncInd from './component/indian_ancestor/levels/niveau-3/FamilyTree';
import Niveau2AncInd from './component/indian_ancestor/levels/niveau-2/FamilyTree';
import Niveau1AncInd from './component/indian_ancestor/levels/niveau-1/FamilyTree';
import ChooseLevel from './component/levels/ChooseLevel';
import ChooseForm from './component/sms/ChooseForm';
import OCISMS from './component/sms/oci-1/FamilyTree';
import AncetreSMS from './component/sms/ancetre-1/FamilyTree';
import ArbreSMS from './component/sms/arbre-1/FamilyTree';
import IdentityCard from './component/forms/identitycard';
import Signature from './component/forms/signature';
import Passport from './component/forms/passport';
import FormQuestion from './component/forms/formUser';

function App() {
  const isDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  const containerStyle = isDarkMode ? "dark:bg-black" : "bg-white";

  return (
    <div className={`App ${containerStyle}`}>
      <header className="App-header">
        <Router>
          <Routes>
            <Route path="/" element={<Navigate to="/familytree" />} />
            <Route path="/familytree" element={<Niveau1 />} />
            <Route path="/procuration" element={<Procuration />} />
            <Route path="/ancetre4" element={<IndianAncestor />} />
            <Route path="/ancetre3" element={<Niveau3AncInd />} />
            <Route path="/ancetre2" element={<Niveau2AncInd />} />
            <Route path="/ancetre1" element={<Niveau1AncInd />} />
            <Route path="/ancetre" element={<Niveau1AncInd />} />
            <Route path="/creneau" element={<Creneau />} />
            <Route path="/oci1" element={<Niveau1 />} />
            <Route path="/oci2" element={<Niveau2 />} />
            <Route path="/oci3" element={<Niveau3 />} />
            <Route path="/oci4" element={<FamilyTree />} />
            <Route path="/choisirform" element={<ChooseLevel />} />
            <Route path="/smschoisirform" element={<ChooseForm />} />
            <Route path="/ocisms" element={<OCISMS />} />
            <Route path="/ancetresms" element={<AncetreSMS />} />
            <Route path="/arbresms" element={<ArbreSMS />} />
            <Route path="/identitycard" element={<IdentityCard />} />
            <Route path="/signature" element={<Signature />} />
            <Route path="/passport" element={<Passport />} />
            <Route path="/formuser" element={<FormQuestion />} />
          </Routes>
        </Router>
      </header>
    </div>
  );
}

export default App;